import { Redirect } from "react-router-dom"
import React from 'react';

const RootPage: React.FC<{}> = () => (
    <Redirect to={{pathname: '/main'}} />
)

export default RootPage;